import React from "react";
import { Link } from "react-router-dom";
import { FaUsers, FaStar } from "react-icons/fa";
import routes from "../../../constants/routes";
import styles from "./HomeMentorships.module.scss";
import PaypalLogo from "../../../assets/paypal-logo.png";
import MercadopagoLogo from "../../../assets/MP_RGB_HANDSHAKE_pluma_horizontal.svg";

const plans = [
  {
    name: "Plan Observador",
    price: "10 USD",
    priceSuffix: "/mes",
    icon: <FaUsers />,
    text: "Este plan es para quienes quieren aprender viendo cómo se resuelven casos reales, sin participar activamente.",
    paypalHref:
      "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-4UT729245A048073FNHCZPZQ",
    mpHref:
      "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c938084934d1f1701936d0906240a54",
  },
  {
    name: "Grupo de soporte Motoasesor",
    price: "40 USD",
    priceSuffix: "/mes",
    icon: <FaStar />,
    highlighted: true,
    text: "Es soporte real de taller + cómo mejorar tus diagnósticos y hacer rentable tu trabajo.",
    paypalHref:
      "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-77S34522MS866783FNHLE4MY",
    mpHref:
      "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c938084915406c2019157a56ed60143",
  },
];

const HomeMentorships = () => {
  return (
    <div className={`section ${styles.section}`}>
      <div className="wrapper">
        <h2 className="section_subtitle center light">
          <span>Consultoría</span> personalizada para cada cliente
        </h2>
        <div className={styles.cards}>
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`${styles.card} ${
                plan.highlighted ? styles.cardHighlighted : ""
              }`}
            >
              <div className={styles.cardHeader}>
                <div className={styles.cardIcon}>{plan.icon}</div>
                <span className={styles.cardPlanName}>{plan.name}</span>
              </div>
              <div className={styles.cardPrice}>
                {plan.price}
                <span>{plan.priceSuffix}</span>
              </div>
              <p className={styles.cardText}>{plan.text}</p>
              <div className={styles.cardActions}>
                <a
                  href={plan.paypalHref}
                  target="_blank"
                  rel="noreferrer"
                  className={styles.btnPaypal}
                >
                  {plan.paypalLabel || "Unirme"}
                  <img src={PaypalLogo} alt="PayPal" />
                </a>
                {plan.mpHref && (
                  <a
                    href={plan.mpHref}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.btnMercadopago}
                  >
                    Unirme
                    <img src={MercadopagoLogo} alt="MercadoPago" />
                  </a>
                )}
                <Link
                  to={routes.mentorships.path}
                  className={styles.btnSecondary}
                >
                  Ver más
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeMentorships;
